
export const faqCategories = [
  { id: 'general', label: 'General', icon: 'ri-question-line' },
  { id: 'venta', label: 'Venta de Vehículos', icon: 'ri-car-line' },
  { id: 'documentacion', label: 'Documentación', icon: 'ri-file-text-line' },
  { id: 'precios', label: 'Precios y Pagos', icon: 'ri-money-euro-circle-line' },
  { id: 'recogida', label: 'Recogida y Grúa', icon: 'ri-truck-line' },
  { id: 'piezas', label: 'Piezas de Recambio', icon: 'ri-settings-3-line' },
  { id: 'legal', label: 'Aspectos Legales', icon: 'ri-scales-3-line' },
  { id: 'medioambiente', label: 'Medio Ambiente', icon: 'ri-leaf-line' },
];

export const faqItems = [
  {
    id: 1,
    category: 'general',
    pregunta: '\u00bfQu\u00e9 es un desguace y c\u00f3mo funciona el de Gav\u00e1?',
    respuesta: 'Un desguace es un Centro Autorizado de Tratamiento (CAT) de veh\u00edculos al final de su vida \u00fatil. En Desguace Gav\u00e1 nos encargamos de comprar tu coche siniestrado, averiado o para chatarra, descontaminarlo de forma segura, recuperar las piezas reutilizables y reciclar los materiales. Somos un desguace profesional con m\u00e1s de 15 a\u00f1os de experiencia en Gav\u00e1 y el Baix Llobregat, cumpliendo toda la normativa medioambiental vigente.',
  },
  {
    id: 2,
    category: 'general',
    pregunta: '\u00bfD\u00f3nde est\u00e1is ubicados exactamente en Gav\u00e1?',
    respuesta: 'Nuestro desguace est\u00e1 ubicado en Gav\u00e1, Barcelona, en la comarca del Baix Llobregat. Damos servicio a toda la zona: Castelldefels, Viladecans, Sant Boi de Llobregat, El Prat de Llobregat, Begues, Sant Climent y m\u00e1s. No necesitas desplazarte, nosotros vamos a recoger tu veh\u00edculo donde est\u00e9.',
  },
  {
    id: 3,
    category: 'general',
    pregunta: '\u00bfCu\u00e1l es vuestro horario de atenci\u00f3n en Gav\u00e1?',
    respuesta: 'Nuestro horario de atenci\u00f3n es de lunes a viernes de 9:00 a 19:00 horas y s\u00e1bados de 9:00 a 14:00 horas. Puedes llamarnos al 936 622 445 o escribirnos por WhatsApp en cualquier momento y te responderemos lo antes posible. Para urgencias fuera de horario, tambi\u00e9n puedes dejarnos un mensaje.',
  },
  {
    id: 4,
    category: 'general',
    pregunta: '\u00bfSois un desguace autorizado y legal en Gav\u00e1?',
    respuesta: 'S\u00ed, somos un Centro Autorizado de Tratamiento (CAT) registrado y homologado por la Generalitat de Catalunya. Cumplimos con toda la normativa vigente en materia de gesti\u00f3n de residuos de veh\u00edculos, lo que garantiza que tu coche ser\u00e1 tratado de forma legal y respetuosa con el medio ambiente. Emitimos certificado de destrucci\u00f3n oficial.',
  },
  {
    id: 5,
    category: 'venta',
    pregunta: '\u00bfQu\u00e9 tipo de coches compr\u00e1is en Gav\u00e1?',
    respuesta: 'Compramos todo tipo de veh\u00edculos en Gav\u00e1 y alrededores: coches siniestrados por accidente, veh\u00edculos averiados con aver\u00edas mec\u00e1nicas graves, coches antiguos que ya no pasan la ITV, furgonetas, todoterrenos, coches para chatarra, veh\u00edculos con motor fundido, coches inundados y cualquier veh\u00edculo al final de su vida \u00fatil. Aceptamos todas las marcas y modelos sin excepci\u00f3n.',
  },
  {
    id: 6,
    category: 'venta',
    pregunta: '\u00bfC\u00f3mo puedo vender mi coche siniestrado en Gav\u00e1?',
    respuesta: 'El proceso es muy sencillo: 1) Ll\u00e1manos al 936 622 445 o escr\u00edbenos por WhatsApp con los datos de tu coche (marca, modelo, a\u00f1o y estado). 2) Te hacemos una valoraci\u00f3n gratuita en menos de 2 horas. 3) Si aceptas, enviamos la gr\u00faa gratis a recoger tu coche en 24 horas. 4) Te pagamos al instante en efectivo o transferencia. 5) Nos encargamos de toda la documentaci\u00f3n y baja en tr\u00e1fico.',
  },
  {
    id: 7,
    category: 'venta',
    pregunta: '\u00bfCompr\u00e1is coches que no arrancan o no se pueden mover?',
    respuesta: 'S\u00ed, compramos coches que no arrancan, que est\u00e1n parados, que no se pueden mover o que llevan tiempo sin funcionar. No importa el estado del veh\u00edculo. Nuestra gr\u00faa se encarga de recogerlo donde est\u00e9 en Gav\u00e1 y toda la comarca del Baix Llobregat, sin ning\u00fan coste para ti.',
  },
  {
    id: 8,
    category: 'venta',
    pregunta: '\u00bfCompr\u00e1is coches sin ITV en vigor en Gav\u00e1?',
    respuesta: 'S\u00ed, compramos veh\u00edculos sin ITV en vigor. No necesitas pasar la ITV para vendernos tu coche. Tambi\u00e9n compramos coches que han sido rechazados en la ITV por defectos graves. El estado de la ITV no afecta a nuestra oferta de compra.',
  },
  {
    id: 9,
    category: 'venta',
    pregunta: '\u00bfPuedo vender un coche que no es m\u00edo?',
    respuesta: 'Para vender un veh\u00edculo necesitas ser el titular registrado en tr\u00e1fico o tener una autorizaci\u00f3n notarial del propietario. En casos de herencia, necesitar\u00e1s la documentaci\u00f3n correspondiente (testamento, aceptaci\u00f3n de herencia). Te asesoramos gratuitamente sobre la documentaci\u00f3n necesaria en cada caso.',
  },
  {
    id: 10,
    category: 'venta',
    pregunta: '\u00bfCompr\u00e1is furgonetas y veh\u00edculos comerciales en Gav\u00e1?',
    respuesta: 'S\u00ed, compramos furgonetas, veh\u00edculos comerciales ligeros, todoterrenos y SUV en cualquier estado. Tambi\u00e9n aceptamos veh\u00edculos de empresa y flotas. Ofrecemos valoraciones competitivas para veh\u00edculos comerciales siniestrados o averiados en Gav\u00e1 y alrededores.',
  },
  {
    id: 11,
    category: 'documentacion',
    pregunta: '\u00bfQu\u00e9 documentaci\u00f3n necesito para vender mi coche al desguace en Gav\u00e1?',
    respuesta: 'Para vender tu coche necesitas: DNI o NIE del titular del veh\u00edculo, permiso de circulaci\u00f3n (tarjeta verde), ficha t\u00e9cnica del veh\u00edculo (tarjeta de la ITV). Nosotros nos encargamos de todo lo dem\u00e1s: baja definitiva en la DGT, certificado de destrucci\u00f3n y cualquier tr\u00e1mite administrativo necesario.',
  },
  {
    id: 12,
    category: 'documentacion',
    pregunta: '\u00bfQui\u00e9n se encarga de dar de baja el coche en tr\u00e1fico?',
    respuesta: 'Nosotros nos encargamos de todo el proceso de baja definitiva en la DGT. Una vez recogemos tu veh\u00edculo, tramitamos la baja y te enviamos el certificado de destrucci\u00f3n oficial. Este documento te libera de cualquier responsabilidad futura sobre el veh\u00edculo, incluyendo impuestos y seguros.',
  },
  {
    id: 13,
    category: 'documentacion',
    pregunta: '\u00bfQu\u00e9 es el certificado de destrucci\u00f3n y para qu\u00e9 sirve?',
    respuesta: 'El certificado de destrucci\u00f3n es un documento oficial que acredita que tu veh\u00edculo ha sido descontaminado y tratado en un centro autorizado. Es imprescindible para la baja definitiva en la DGT. Con este certificado dejas de pagar el impuesto de circulaci\u00f3n, puedes cancelar el seguro y te liberas de cualquier responsabilidad legal sobre el veh\u00edculo.',
  },
  {
    id: 14,
    category: 'documentacion',
    pregunta: '\u00bfPuedo vender mi coche al desguace si he perdido la documentaci\u00f3n?',
    respuesta: 'S\u00ed, aunque hayas perdido el permiso de circulaci\u00f3n o la ficha t\u00e9cnica, podemos ayudarte. Gestionamos la obtenci\u00f3n de duplicados en la DGT o buscamos soluciones alternativas. Ll\u00e1manos y te asesoramos sobre c\u00f3mo proceder en tu caso concreto sin ning\u00fan compromiso.',
  },
  {
    id: 15,
    category: 'documentacion',
    pregunta: '\u00bfQu\u00e9 pasa con el seguro del coche cuando lo vendo al desguace?',
    respuesta: 'Una vez que te entreguemos el certificado de destrucci\u00f3n, puedes contactar con tu compa\u00f1\u00eda de seguros para cancelar la p\u00f3liza. Tendr\u00e1s derecho a la devoluci\u00f3n proporcional de la prima no consumida. Te recomendamos no cancelar el seguro hasta tener el certificado en mano.',
  },
  {
    id: 16,
    category: 'precios',
    pregunta: '\u00bfCu\u00e1nto pag\u00e1is por un coche para desguace en Gav\u00e1?',
    respuesta: 'El precio depende de varios factores: marca y modelo del veh\u00edculo, a\u00f1o de matriculaci\u00f3n, estado general, peso del veh\u00edculo y demanda de sus piezas de recambio. Ofrecemos las mejores valoraciones del mercado en Gav\u00e1. Ll\u00e1manos con los datos de tu coche y te damos un presupuesto gratuito y sin compromiso en menos de 2 horas.',
  },
  {
    id: 17,
    category: 'precios',
    pregunta: '\u00bfC\u00f3mo se calcula el precio de mi coche siniestrado?',
    respuesta: 'Valoramos tu coche siniestrado en funci\u00f3n de: el valor de las piezas recuperables (motor, caja de cambios, electr\u00f3nica, carrocer\u00eda), el peso del veh\u00edculo para reciclaje de metales, la marca y modelo (algunos tienen m\u00e1s demanda de piezas), y el estado general. Siempre ofrecemos un precio justo y transparente.',
  },
  {
    id: 18,
    category: 'precios',
    pregunta: '\u00bfEl servicio de recogida con gr\u00faa tiene alg\u00fan coste?',
    respuesta: 'No, el servicio de recogida con gr\u00faa es 100% gratuito en Gav\u00e1 y toda la comarca del Baix Llobregat. No hay costes ocultos ni cargos adicionales. El precio que te ofrecemos es neto, sin descontar nada por transporte ni gesti\u00f3n.',
  },
  {
    id: 19,
    category: 'precios',
    pregunta: '\u00bfC\u00f3mo y cu\u00e1ndo me pag\u00e1is por mi coche?',
    respuesta: 'El pago se realiza en el momento de la recogida del veh\u00edculo. Puedes elegir entre pago en efectivo o transferencia bancaria instant\u00e1nea. No hay esperas, no hay plazos. Recoges tu dinero el mismo d\u00eda que nos llevamos el coche.',
  },
  {
    id: 20,
    category: 'precios',
    pregunta: '\u00bfLa valoraci\u00f3n es gratuita y sin compromiso?',
    respuesta: 'S\u00ed, la valoraci\u00f3n de tu veh\u00edculo es completamente gratuita y sin ning\u00fan compromiso. Puedes pedirnos presupuesto por tel\u00e9fono o WhatsApp y decidir con tranquilidad. No hay obligaci\u00f3n de aceptar nuestra oferta.',
  },
  {
    id: 21,
    category: 'precios',
    pregunta: '\u00bfPuedo negociar el precio de mi coche?',
    respuesta: 'Siempre ofrecemos un precio justo desde el primer momento basado en el valor real del veh\u00edculo. Si tienes otra oferta de otro desguace en Gav\u00e1 o alrededores, d\u00ednoslo y haremos lo posible por igualarla o mejorarla. Queremos que quedes satisfecho con la transacci\u00f3n.',
  },
  {
    id: 22,
    category: 'recogida',
    pregunta: '\u00bfEn cu\u00e1nto tiempo recog\u00e9is el coche en Gav\u00e1?',
    respuesta: 'Normalmente recogemos el veh\u00edculo en 24 horas desde que aceptas nuestra oferta. En muchos casos podemos recogerlo el mismo d\u00eda. Si tienes urgencia, ind\u00edcanoslo y priorizaremos tu recogida. Cubrimos Gav\u00e1, Castelldefels, Viladecans, Sant Boi y toda la comarca.',
  },
  {
    id: 23,
    category: 'recogida',
    pregunta: '\u00bfRecog\u00e9is coches en garajes subterr\u00e1neos o zonas de dif\u00edcil acceso?',
    respuesta: 'S\u00ed, disponemos de gr\u00faas de diferentes tama\u00f1os para adaptarnos a cualquier situaci\u00f3n. Podemos recoger veh\u00edculos en garajes subterr\u00e1neos, calles estrechas, parkings privados o cualquier ubicaci\u00f3n en Gav\u00e1 y alrededores. Nuestros profesionales eval\u00faan la mejor forma de acceso.',
  },
  {
    id: 24,
    category: 'recogida',
    pregunta: '\u00bfQu\u00e9 zonas cubr\u00eds para la recogida de veh\u00edculos?',
    respuesta: 'Cubrimos toda la comarca del Baix Llobregat y alrededores: Gav\u00e1, Castelldefels, Viladecans, Sant Boi de Llobregat, El Prat de Llobregat, Cornell\u00e0, Begues, Sant Climent de Llobregat, Sitges, y m\u00e1s. Si est\u00e1s en otra zona, cons\u00faltanos y seguramente tambi\u00e9n podamos atenderte.',
  },
  {
    id: 25,
    category: 'recogida',
    pregunta: '\u00bfNecesito estar presente cuando recoj\u00e1is el coche?',
    respuesta: 'S\u00ed, es necesario que el titular del veh\u00edculo o una persona autorizada est\u00e9 presente en el momento de la recogida para firmar la documentaci\u00f3n de transferencia y recibir el pago. Coordinamos la hora que mejor te venga.',
  },
  {
    id: 26,
    category: 'piezas',
    pregunta: '\u00bfVend\u00e9is piezas de segunda mano en Gav\u00e1?',
    respuesta: 'S\u00ed, disponemos de un amplio cat\u00e1logo de piezas de recambio de segunda mano procedentes de los veh\u00edculos que procesamos. Motores, cajas de cambios, alternadores, puertas, faros, espejos y mucho m\u00e1s. Todas las piezas son revisadas y ofrecemos garant\u00eda.',
  },
  {
    id: 27,
    category: 'piezas',
    pregunta: '\u00bfLas piezas de segunda mano tienen garant\u00eda?',
    respuesta: 'S\u00ed, todas nuestras piezas de recambio incluyen garant\u00eda. El periodo de garant\u00eda var\u00eda seg\u00fan el tipo de pieza: motores y cajas de cambios tienen garant\u00eda extendida, mientras que piezas de carrocer\u00eda y electr\u00f3nica tienen garant\u00eda est\u00e1ndar. Consulta las condiciones espec\u00edficas al comprar.',
  },
  {
    id: 28,
    category: 'piezas',
    pregunta: '\u00bfC\u00f3mo puedo saber si ten\u00e9is la pieza que necesito?',
    respuesta: 'Ll\u00e1manos al 936 622 445 o escr\u00edbenos por WhatsApp indicando la pieza que necesitas, la marca, modelo y a\u00f1o de tu veh\u00edculo. Consultamos nuestro inventario y te confirmamos disponibilidad y precio en el momento. Si no la tenemos, podemos buscarla en nuestra red de desguaces colaboradores.',
  },
  {
    id: 29,
    category: 'piezas',
    pregunta: '\u00bfHac\u00e9is env\u00edos de piezas fuera de Gav\u00e1?',
    respuesta: 'S\u00ed, realizamos env\u00edos de piezas a toda Espa\u00f1a. Para la zona de Gav\u00e1 y Baix Llobregat ofrecemos entrega r\u00e1pida. Para el resto de la pen\u00ednsula, enviamos por agencia de transporte con seguimiento. Consulta plazos y costes de env\u00edo.',
  },
  {
    id: 30,
    category: 'legal',
    pregunta: '\u00bfEs legal vender mi coche a un desguace en Gav\u00e1?',
    respuesta: 'S\u00ed, es completamente legal siempre que el desguace sea un Centro Autorizado de Tratamiento (CAT) como el nuestro. Desguace Gav\u00e1 est\u00e1 registrado y autorizado por la Generalitat de Catalunya. Emitimos toda la documentaci\u00f3n legal necesaria para que la transacci\u00f3n sea transparente y segura.',
  },
  {
    id: 31,
    category: 'legal',
    pregunta: '\u00bfQu\u00e9 pasa si mi coche tiene una reserva de dominio o financiaci\u00f3n?',
    respuesta: 'Si tu coche tiene una reserva de dominio (est\u00e1 financiado), necesitar\u00e1s cancelarla antes de poder venderlo al desguace. Puedes contactar con tu entidad financiera para solicitar la cancelaci\u00f3n. Te asesoramos gratuitamente sobre c\u00f3mo gestionar este tr\u00e1mite.',
  },
  {
    id: 32,
    category: 'legal',
    pregunta: '\u00bfQu\u00e9 responsabilidad tengo despu\u00e9s de vender mi coche al desguace?',
    respuesta: 'Una vez que te entregamos el certificado de destrucci\u00f3n y tramitamos la baja en la DGT, quedas completamente liberado de cualquier responsabilidad sobre el veh\u00edculo. No tendr\u00e1s que pagar m\u00e1s impuesto de circulaci\u00f3n, ni seguro, ni responder por multas futuras.',
  },
  {
    id: 33,
    category: 'legal',
    pregunta: '\u00bfPuedo vender un coche heredado al desguace en Gav\u00e1?',
    respuesta: 'S\u00ed, puedes vender un coche heredado. Necesitar\u00e1s la documentaci\u00f3n de la herencia (testamento, escritura de aceptaci\u00f3n de herencia) y realizar el cambio de titularidad o aportar la documentaci\u00f3n que acredite tu derecho. Te ayudamos con todo el proceso y te asesoramos sin compromiso.',
  },
  {
    id: 34,
    category: 'medioambiente',
    pregunta: '\u00bfC\u00f3mo se recicla un coche en el desguace de Gav\u00e1?',
    respuesta: 'El proceso de reciclaje sigue un protocolo estricto: primero se descontamina el veh\u00edculo (se retiran l\u00edquidos, bater\u00eda, neum\u00e1ticos y componentes peligrosos). Luego se recuperan las piezas reutilizables. Finalmente, la carrocer\u00eda se compacta y se env\u00eda a la fragmentadora para reciclar los metales. Se recicla m\u00e1s del 95% del veh\u00edculo.',
  },
  {
    id: 35,
    category: 'medioambiente',
    pregunta: '\u00bfQu\u00e9 porcentaje de un coche se puede reciclar?',
    respuesta: 'Seg\u00fan la normativa europea, se debe reciclar al menos el 95% del peso del veh\u00edculo. En Desguace Gav\u00e1 cumplimos y superamos este objetivo. Los metales (acero, aluminio, cobre) se funden y reutilizan, los pl\u00e1sticos se reciclan, los neum\u00e1ticos se valorizan y los l\u00edquidos se tratan de forma segura.',
  },
  {
    id: 36,
    category: 'medioambiente',
    pregunta: '\u00bfVender mi coche al desguace es mejor para el medio ambiente que dejarlo abandonado?',
    respuesta: 'Absolutamente s\u00ed. Un coche abandonado contamina el suelo y las aguas subterr\u00e1neas con aceites, l\u00edquidos de freno y refrigerante. En un desguace autorizado como el nuestro en Gav\u00e1, todos estos contaminantes se gestionan de forma segura. Adem\u00e1s, reciclar los materiales reduce la necesidad de extraer nuevas materias primas.',
  },
  {
    id: 37,
    category: 'medioambiente',
    pregunta: '\u00bfQu\u00e9 normativa medioambiental cumpl\u00eds en Gav\u00e1?',
    respuesta: 'Cumplimos con el Real Decreto 265/2021 sobre veh\u00edculos al final de su vida \u00fatil, la Directiva Europea 2000/53/CE, la normativa catalana de gesti\u00f3n de residuos y todas las regulaciones municipales de Gav\u00e1. Somos auditados peri\u00f3dicamente para garantizar el cumplimiento de todos los est\u00e1ndares medioambientales.',
  },
];
